<template>
	<div class="schedule-list-table">
		<div class="schedule-list-table-eachDay" v-for="(item, index) in scheduleList" :key="index">
			<div class="schedule-list-table-date">
				<span :class="index == 0?'schedule-list-table-head-text':''">{{item.date}}</span>
				<span v-if="item.weekday">{{item.weekday}}</span>
			</div>
			<div class="schedule-list-table-info">
				<div class="schedule-list-table-info-each" v-for="(scheduleItem, scheduleIndex) in item.scheduleInfo"
					:key="scheduleIndex"
					:class="(scheduleItem.number || scheduleItem.number == 0)?scheduleItem.number%2 == 0?'schedule-list-table-info-each-even':'schedule-list-table-info-each-odd':''">
					<div class="schedule-list-table-info-each-text"
						:class="index == 0?'schedule-list-table-head-text':''">
						<span
							:class="item.isCurrentDate?'schedule-list-table-info-each-text-currentDate':''">{{index == 0?'序号':scheduleIndex + 1}}</span>
					</div>
					<div class="schedule-list-table-info-each-text"
						:class="index == 0?'schedule-list-table-head-text':''">
						<span
							:class="item.isCurrentDate?'schedule-list-table-info-each-text-currentDate':''">{{scheduleItem.start_time}}</span>
					</div>
					<div class="schedule-list-table-info-each-text" style="flex: 4;"
						:class="index == 0?'schedule-list-table-head-text':''">
						<span
							:class="item.isCurrentDate?'schedule-list-table-info-each-text-currentDate':''">{{scheduleItem.content}}</span>
					</div>
					<div class="schedule-list-table-info-each-text" style="flex: 3;"
						:class="index == 0?'schedule-list-table-head-text':''">
						<span
							:class="item.isCurrentDate?'schedule-list-table-info-each-text-currentDate':''">{{scheduleItem.location}}</span>
					</div>
					<div class="schedule-list-table-info-each-text" style="flex: 3;"
						:class="index == 0?'schedule-list-table-head-text':''">
						<span
							:class="item.isCurrentDate?'schedule-list-table-info-each-text-currentDate':''">{{scheduleItem.leaders}}</span>
					</div>
					<div class="schedule-list-table-info-each-text"
						:class="index == 0?'schedule-list-table-head-text':''">
						<span
							:class="item.isCurrentDate?'schedule-list-table-info-each-text-currentDate':''">{{scheduleItem.createUser}}</span>
					</div>
					<div v-if="index == 0" class="schedule-list-table-btns">
						<span :class="index == 0?'schedule-list-table-head-text':''">操作</span>
					</div>
					<div v-else class="schedule-list-table-btns">
						<span class="schedule-list-table-btns-text" @click="viewScheduleInfo(scheduleItem)">查看</span>
						<img class="schedule-list-table-btns-edit" @click="editScheduleInfo(scheduleItem)"
							src="../../assets/common/icons/editScheduleIcon.png" />
						<el-popover placement="left" width="400" trigger="click" ref="deletePopover"
							popper-class="schedule-list-table-btns-popover">
							<img src="../../assets/common/icons/deleteScheduleIcon.png" slot="reference" />
							<tipsModal :modalTitle="'温馨提示'" :modalContent="'确定删除此项日程？'"
								@hideModal="hideModal(scheduleItem.number)" @modalConfirm="modalConfirm(scheduleItem)">
							</tipsModal>
						</el-popover>
					</div>
				</div>
			</div>
		</div>
		<el-dialog :visible.sync="isShowEditSchedule" :close-on-click-modal="false">
			<div slot="title" class="dialog-title">
				<span>日程详情</span>
			</div>
			<editSchedule :memberList="memberList" :useMode="useMode" :scheduleInfo="scheduleInfo"
				@confirmEditSchedule="confirmEditSchedule" :viewUserId="viewUserId">
			</editSchedule>
		</el-dialog>
	</div>
</template>

<script>
	import editSchedule from './EditSchedule.vue';
	import tipsModal from '../tools/TipsModal.vue';
	export default {
		components: {
			editSchedule,
			tipsModal
		},
		props: {
			memberList: { //人员管理列表
				type: Array,
				default: []
			},
			viewUserId: { //当前查看的用户Id
				type: Number,
				default: -1
			},
			userId: { //用户Id
				type: Number,
				default: -1
			},
			currentPage: { //当前查询第几页
				type: Number,
				default: 1
			},
			isSearchMode: { //是否开启搜索模式
				type: Boolean,
				default: false,
			}
		},
		data() {
			return {
				scheduleList: [], //日程列表数据
				isShowEditSchedule: false, //是否显示编辑日程弹窗
				scheduleInfo: '', //当前选中编辑/查看的日程信息
				size: 10, //日程列表单次请求条数
				listViewMode: 1, //请求的日程列表数据模式：1、未发生；2、历史
				loading: '', //加载中
				useMode: 'edit', //编辑日程模式
				searchInfo: {}, //搜索信息
				userInfo: '', //用户信息
			}
		},
		mounted() {
			let that = this;
			that.$nextTick(() => {
				that.userInfo = JSON.parse(localStorage.getItem('userInfo'));
				that.$bus.$on('changeScheduleView', (flag) => {
					if (flag == 3) { //日视图
						that.listViewMode = 1;
					} else if (flag == 4) { //周视图
						that.listViewMode = 2;
					}
				})
				that.$bus.$on('updateScheduleList', () => {
					that.getSchedule(true);
				})
				that.$bus.$on('searchSchedule', (res) => {
					that.searchInfo = JSON.parse(res);
					that.getSchedule(true);
				})
			})
		},
		watch: {
			viewUserId: {
				handler(newViewUserId, oldViewUserId) {
					let that = this;
					if (newViewUserId != -1) {
						that.getUserInfo(that.viewUserId);
					}
				},
				immediate: true,
				deep: true
			},
			listViewMode: {
				handler(newListViewMode, oldListViewMode) {
					let that = this;
					if (that.viewUserId != -1) {
						that.getSchedule(true);
					}
				},
				immediate: true,
				deep: true
			},
			currentPage: {
				handler(newCurrentPage, oldCurrentPage) {
					let that = this;
					if (that.viewUserId != -1) {
						that.getSchedule(false);
					}
				},
				immediate: true,
				deep: true
			},
		},
		methods: {
			//点击指定用户信息
			getUserInfo(userId) {
				let that = this;
				let params = {
					userId: userId
				};
				that.$api.getUserInfo(params).then(res => {
					// console.log(res)
					if (res.code == 1) {
						if (that.userId != that.viewUserId || res.data.role == 1 || res.data.role == 2) {
							that.searchInfo.name = res.data.name;
						} else {
							that.searchInfo.name = '';
						}
						that.getSchedule(true);
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//获取日程信息
			getSchedule(update) {
				let that = this;
				if (update) {
					that.currentPage = 1;
				}
				that.loading = that.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				if (that.isSearchMode && JSON.stringify(that.searchInfo) !== "{}") {
					let params = that.searchInfo;
					that.searchInfo.page = that.currentPage;
					that.searchInfo.size = that.size;
					if (that.userId == that.viewUserId && that.userInfo.role != 1 && that.userInfo.role != 2) {
						params.scheduleUserId = that.userId;
					}
					that.$api.searchSchedule(params).then(res => {
						console.log(res)
						if (res.code == 1) {
							that.handleScheduleData(res);
						} else {
							that.loading.close();
						}
					}).catch(err => {
						console.log(err)
						that.loading.close();
					})
				} else {
					let params = {
						userId: that.viewUserId,
						page: that.currentPage,
						size: that.size
					};
					if (that.viewUserId == that.userId && that.userInfo.role != 1 && that.userInfo.role != 2) {
						params.scheduleUserId = that.userId;
						params.userId = -1;
						that.$api.getScheduleWithPageAndScheduleUserId(params).then(res => {
							console.log(res)
							if (res.code == 1) {
								that.handleScheduleData(res);
							} else {
								that.loading.close();
							}
						}).catch(err => {
							console.log(err)
							that.loading.close();
						})
					} else {
						that.$api.getScheduleWithPage(params).then(res => {
							console.log(res)
							if (res.code == 1) {
								that.handleScheduleData(res);
							} else {
								that.loading.close();
							}
						}).catch(err => {
							console.log(err)
							that.loading.close();
						})
					}
				}
			},
			//处理日程数据
			handleScheduleData(res) {
				let that = this;
				if (that.listViewMode == 1) {
					if (that.viewUserId != 1) {
						that.getRepresentation(res.future.data);
					} else {
						that.assembleSchedule(res.future.data);
						that.$bus.$emit('getScheduleList', res.future);
					}
				} else if (that.listViewMode == 2) {
					if (that.viewUserId != 1) {
						that.getRepresentation(res.history.data);
					} else {
						that.assembleSchedule(res.history.data);
						that.$bus.$emit('getScheduleList', res.history);
					}
				}
			},
			//获取用户修改的日程
			getRepresentation(scheduleList) {
				let that = this;
				let params = {
					userId: that.viewUserId
				};
				that.$api.getRepresentation(params).then(res => {
					console.log(res)
					if (res.code == 1) {
						scheduleList.forEach((item, index) => {
							res.data.forEach((resItem, resIndex) => {
								if (item.scheduleId == resItem.scheduleId) {
									scheduleList[index] = JSON.parse(resItem.content);
									scheduleList[index].representationId = resItem.id;
								}
							})
						})
						that.assembleSchedule(scheduleList);
					} else {
						that.loading.close();
					}
				}).catch(err => {
					console.log(err)
					that.loading.close();
				})
			},
			//组装数据
			assembleSchedule(scheduleData) {
				let that = this;
				let scheduleList = [{
					date: '日期',
					scheduleInfo: [{
						start_time: '开始时间',
						content: '内容',
						location: '地点',
						leaders: '校领导',
						createUser: '创建人'
					}]
				}];
				console.log(scheduleData)
				if (scheduleData.length == 0) {
					that.$bus.$emit("noData", true);
				} else {
					that.$bus.$emit("noData", false);
					scheduleData.forEach((item, index) => {
						item.start_time = that.$utils.fmtDate(new Date(item.startTime), 'yyyy-MM-dd hh:mm');
						let scheduleDate = item.start_time.split(" ")[0].split("-")[1] + "-" + item.start_time
							.split(
								" ")[0].split("-")[2];
						let isCurrentDate = false;
						if (that.$utils.fmtDate(new Date(), "yyyy-MM-dd") == that.$utils.fmtDate(new Date(item
									.start_time),
								"yyyy-MM-dd")) {
							isCurrentDate = true;
						}
						let scheduleDay = new Date(item.start_time).getDay();
						let scheduleStartTime = item.start_time.split(" ")[1];
						let leaderListText = "";
						item.school_leaders.forEach((leaderItem, leaderIndex) => {
							if (!leaderListText) {
								leaderListText = leaderItem.name;
							} else {
								leaderListText = leaderListText + "、" + leaderItem.name;
							}
						})
						let scheduleInfo = item;
						scheduleInfo.startTime = item.start_time;
						scheduleInfo.start_time = scheduleStartTime;
						scheduleInfo.leaders = leaderListText;
						if (item.scheduleUserInform) {
							scheduleInfo.createUser = item.scheduleUserInform.name;
						}
						scheduleInfo.number = index;
						let hasAdded = false;
						scheduleList.forEach((scheduleItem, scheduleIndex) => {
							if (scheduleItem.date == scheduleDate) {
								scheduleList[scheduleIndex].scheduleInfo.push(scheduleInfo);
								hasAdded = true;
							}
						})
						if (!hasAdded) {
							let tempList = [];
							tempList.push(scheduleInfo);
							scheduleList.push({
								date: scheduleDate,
								weekday: that.$utils.getWeekDayByNum(scheduleDay),
								scheduleInfo: tempList,
								isCurrentDate: isCurrentDate
							});
						}
					});
				}
				console.log(scheduleList)
				that.scheduleList = scheduleList;
				that.loading.close();
			},
			//点击查看日程信息
			viewScheduleInfo(scheduleInfo) {
				let that = this;
				that.useMode = 'view';
				that.isShowEditSchedule = true;
				that.scheduleInfo = scheduleInfo;
			},
			//编辑日程信息
			editScheduleInfo(scheduleInfo) {
				let that = this;
				that.useMode = 'edit';
				that.isShowEditSchedule = true;
				that.scheduleInfo = scheduleInfo;
			},
			//点击完成编辑日程
			confirmEditSchedule() {
				let that = this;
				that.getSchedule(true);
				that.isShowEditSchedule = false;
			},
			//点击隐藏删除弹窗提示
			hideModal(index) {
				let that = this;
				that.$refs['deletePopover'][index].doClose();
			},
			//点击确认执行模态框的操作
			modalConfirm(scheduleInfo) {
				let that = this;
				that.$refs['deletePopover'][scheduleInfo.number].doClose();
				that.deleteSchedule(scheduleInfo);
			},
			//点击删除日程
			deleteSchedule(scheduleInfo) {
				let that = this;
				let params = {
					uuid: scheduleInfo.uuid,
					scheduleId: scheduleInfo.scheduleId
				};
				let deleteScheduleFun;
				if (that.userId == that.viewUserId && that.userInfo.role != 1 && that.userInfo.role != 2) {
					deleteScheduleFun = that.$api.deleteSchedule(params);
				} else {
					if (scheduleInfo.representationId || scheduleInfo.representationId == 0) {
						params.id = scheduleInfo.representationId;
					} else {
						params.id = -1;
					}
					params.userId = that.viewUserId;
					deleteScheduleFun = that.$api.deleteRepresentation(params);
				}
				// console.log(params)
				deleteScheduleFun.then(res => {
					console.log(res)
					if (res.code == 1) {
						that.getSchedule(true);
					}
				}).catch(err => {
					console.log(err)
				})
			},
		}
	}
</script>

<style lang="scss">
	.schedule-list-table {
		display: flex;
		flex-direction: column;
		border-bottom: 1px solid #999999;
		background-color: #F2F8FF;

		.schedule-list-table-eachDay {
			display: flex;
			flex-direction: row;
			align-items: stretch;
			justify-content: flex-start;
			border-left: 1px solid #999999;

			.schedule-list-table-head-text {
				font-weight: 400;
				color: #666666;
			}

			.schedule-list-table-date {
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				border-top: 1px solid #999999;
				flex-shrink: 0;

				span {
					font-weight: 400;
					color: #333333;
				}

				span:last-child {
					margin: 4px 0 0;
				}
			}

			.schedule-list-table-info {
				display: flex;
				flex-direction: column;
				align-items: flex-start;
				justify-content: center;
				width: 100%;

				.schedule-list-table-info-each {
					display: flex;
					flex-direction: row;
					align-items: stretch;
					justify-content: flex-start;
					border: 1px solid #999999;
					border-bottom: 0;
					width: 100%;

					.schedule-list-table-info-each-text {
						display: flex;
						flex-direction: row;
						align-items: center;
						justify-content: center;
						border-right: 1px solid #999999;
						flex: 1;
						flex-shrink: 0;

						span {
							font-weight: 400;
							color: #333333;
						}

						.schedule-list-table-info-each-text-currentDate {
							color: #E2062A;
						}
					}

					.schedule-list-table-btns {
						display: flex;
						flex-direction: row;
						align-items: center;
						justify-content: center;

						img {
							cursor: pointer;
						}

						.schedule-list-table-btns-text {
							background: #1A66FE;
							font-weight: 400;
							color: #FFFFFF;
							cursor: pointer;
						}
					}
				}

				.schedule-list-table-info-each-even {
					background-color: #CBE4FD;
				}

				.schedule-list-table-info-each-odd {
					background-color: #F4F4F4;
				}
			}
		}

		.dialog-title-delete {
			justify-content: flex-start;
		}
	}

	.schedule-list-table-btns-popover {
		padding: 0;
		border: 0;
		overflow: hidden;
	}

	@media screen and (min-width: 1024px) {
		.schedule-list-table {
			.schedule-list-table-eachDay {
				.schedule-list-table-head-text {
					font-size: 14px;
					padding: 11px 0;
				}

				.schedule-list-table-date {
					padding: 0 12px;
					width: 72px;

					span {
						font-size: 14px;
					}
				}

				.schedule-list-table-info {
					.schedule-list-table-info-each {
						.schedule-list-table-info-each-text {
							min-width: 60px;
							padding: 4px;

							span {
								font-size: 14px;
							}
						}

						.schedule-list-table-btns {
							padding: 6px 20px;
							width: 156px;

							.schedule-list-table-btns-text {
								border-radius: 3px;
								padding: 6px 9px;
								font-size: 14px;
							}

							img {
								width: 25px;
								height: 25px;
							}

							.schedule-list-table-btns-edit {
								margin: 0 9px;
							}
						}

						.el-popover__reference-wrapper {
							height: 25px;
							width: 25px;
						}
					}
				}
			}
		}

		.schedule-list-table-btns-popover {
			border-radius: 11px;
		}
	}

	@media screen and (min-width: 1280px) {}

	@media screen and (min-width: 1366px) {}

	@media screen and (min-width: 1440px) {}

	@media screen and (min-width: 1680px) {
		.schedule-list-table {
			.schedule-list-table-eachDay {
				.schedule-list-table-head-text {
					font-size: 21px;
					padding: 16px 0;
				}

				.schedule-list-table-date {
					padding: 0 20px;
					width: 85px;

					span {
						font-size: 22px;
					}
				}

				.schedule-list-table-info {
					.schedule-list-table-info-each {
						.schedule-list-table-info-each-text {
							min-width: 86px;

							span {
								font-size: 22px;
							}
						}

						.schedule-list-table-btns {
							padding: 6px 20px;
							width: 190px;

							.schedule-list-table-btns-text {
								border-radius: 5px;
								padding: 11px 15px;
								font-size: 21px;
							}

							img {
								width: 40px;
								height: 40px;
							}

							.schedule-list-table-btns-edit {
								margin: 0 16px;
							}
						}

						.el-popover__reference-wrapper {
							height: 40px;
							width: 40px;
						}
					}
				}
			}
		}

		.schedule-list-table-btns-popover {
			border-radius: 11px;
		}
	}

	@media screen and (min-width: 1920px) {}
</style>